import { fetchAuthToken } from "app/Auth";
import { client } from "common/apiClient";

export const updateOnboarding = async ({ uid }: { uid: string }) => {
  const token = await fetchAuthToken();
  await client({ token: token }).put(`/v1/user/config/${uid}/onboarding`);
  return;
};
